import { Spacing } from '@persona-id/design-tokens';
import { ReactNode } from 'react';
import styled from 'styled-components';

import { Paragraph } from 'design-system/components/Text';
import { FontWeight } from 'design-system/variables/text';

const Container = styled('div')`
  height: 180px;
  display: grid;
  align-content: center;
  justify-items: center;
  padding: ${Spacing[4]};
`;

const StyledParagraph = styled(Paragraph)`
  text-align: center;
`;

const BoldParagraph = styled(StyledParagraph)`
  font-weight: ${FontWeight.Medium};
`;

interface NullStateProps {
  icon?: ReactNode;
  header: string;
  description: string;
}

const NullState = ({ icon, header, description }: NullStateProps) => {
  return (
    <Container>
      {icon}
      <BoldParagraph size='sm'>{header}</BoldParagraph>
      <StyledParagraph size='sm'>{description}</StyledParagraph>
    </Container>
  );
};

export default NullState;
